import { contactFormName } from '@/stores/contactFormStore';
import { useRecoilState } from 'recoil';
import { useLocalization } from '@/services/localizationService';
import TextField from '../TextField';

export default function NameField() {
  const [name, setName] = useRecoilState(contactFormName);
  const { data } = useLocalization();
  return (
    <TextField
      placeHolder={data.support.fullName}
      value={name}
      onChange={setName}
      maxLength={100}
    />
  );
}
